import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 6 6",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m1.125 3.625.361.77a.833.833 0 0 0 1.478.061l1.911-3.331" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />' }
  })
);